import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding-left: ${({ theme }): string => theme.spacing_unit_x2};
  padding-right: ${({ theme }): string => theme.spacing_unit_x2};
  padding-top: ${({ theme }): string => theme.spacing_unit_x2};
  padding-bottom: ${({ theme }): string => theme.spacing_unit_x2};

  ${({ theme }): FlattenSimpleInterpolation => css`
    @media (min-width: ${theme.breakpoints_md}) {
      padding-left: ${theme.spacing_unit_x4};
      padding-right: ${theme.spacing_unit_x4};
      padding-top: ${theme.spacing_unit_x4};
      padding-bottom: ${theme.spacing_unit_x4};
    }

    @media (min-width: ${theme.breakpoints_lg}) {
      padding-left: ${theme.spacing_unit_x8};
      padding-right: ${theme.spacing_unit_x8};
    }
  `}
`;

export const Header = styled.header`
  width: 100%;

  & > a {
    padding: 0;
  }

  & > h2:first-of-type {
    margin-bottom: ${({ theme }): string => theme.spacing_unit_x2};
  }
`;

export const Main = styled.main`
  width: 100%;
`;

export const BudgetsWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  gap: ${({ theme }): string => theme.spacing_unit_x2};
  margin-bottom: ${({ theme }): string => theme.spacing_unit_x2};
`;

export const StyledHr = styled.hr<{ fit?: boolean }>`
  width: 100%;
  border: none;
  height: ${({ fit }): string => (fit ? '1px' : '2px')};
  background-color: ${({ theme, fit }): string =>
    fit ? theme.palette_blue_5 : theme.palette_blue_100};
  border-radius: ${({ theme }): string => theme.border_radius_x1};
`;

export const BudgetCard = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 120px;
  border-radius: ${({ theme }): string => theme.border_radius_x2};
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  padding-left: ${({ theme }): string => theme.spacing_unit_x1};
  padding-right: ${({ theme }): string => theme.spacing_unit_x1};
  padding-top: ${({ theme }): string => theme.spacing_unit_x2};
  padding-bottom: ${({ theme }): string => theme.spacing_unit_x1};
  cursor: pointer;
  ${({ selected, theme }): { [key: string]: string } =>
    selected ? { backgroundColor: theme.palette_blue_5 } : {}};

  svg {
    min-height: 22px;
    min-width: 20px;
    margin-bottom: ${({ theme }): string => theme.spacing_unit_x1};
  }
`;

export const ParagraphWithEllipsis = styled.span`
  display: flex;
  min-height: 3em;
  text-align: center;
  align-items: center;
  text-overflow: ellipsis;
`;

export const BudgetAmount = styled.strong`
  font-size: 0.875rem;
  line-height: 1.125rem;
  margin-right: ${({ theme }): string => theme.spacing_unit_x1};
`;

export const BudgetAmountWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }): string => theme.spacing_unit_x1};

  b {
    margin-right: ${({ theme }): string => theme.spacing_unit_x1};
  }
`;

export const BudgetWrapper = styled.div`
  display: flex;
  flex-direction: column;

  hr {
    width: 100%;
  }
`;

export const Spacing = styled.div<{ removeLeft?: boolean }>`
  margin: ${({ theme }): string => `${theme.spacing_unit_x2} 0`};
  margin-left: ${({ removeLeft }): string => (removeLeft ? '-8px' : '0px')};
`;

export const BudgetTileWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }): string => theme.spacing_unit_x2};
  flex-wrap: nowrap;

  ${({ theme }): FlattenSimpleInterpolation => css`
    @media (max-width: ${theme.breakpoints_sm}) {
      flex-direction: column;
    }
  `}
`;

export const StyledDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: ${({ theme }): string => theme.spacing_unit_x1};
  margin-bottom: ${({ theme }): string => theme.spacing_unit_x2};
`;

// TODO: Remove at later stage when every implementation is replaced by the newly created Atom
export const ImageWrapper = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: ${({ theme }): string => theme.palette_blue_5};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${({ theme }): string => theme.spacing_unit_x1};

  img {
    max-width: 22px;
    max-height: 22px;
  }

  & > svg {
    max-width: 22px;
    max-height: 22px;
    fill: ${({ theme }): string => theme.palette_blue_100};
  }
`;

export const Transaction = styled.div<{ marginTop?: boolean }>`
  display: flex;
  margin-bottom: ${({ theme }): string => theme.spacing_unit_x2};
  justify-content: space-between;
  align-items: center;
  max-width: 800px;
  position: relative;
  margin-top: ${({ marginTop = false, theme }): string =>
    marginTop === true ? `calc(${theme.spacing_unit_x1} + 1.25rem)` : '0'};
`;

export const FlexWrapper = styled.div<{ positive?: boolean }>`
  color: ${({ theme, positive }): string =>
    positive ? theme.palette_success_50 : theme.palette_gray_100};
  display: flex;
  margin-right: ${({ theme }): string => theme.spacing_unit_x1};
  align-items: center;
`;

export const StyledStrong = styled.strong`
  margin-right: ${({ theme }): string => theme.spacing_unit_x1};
`;

export const StyledParagraph = styled.p`
  color: ${({ theme }): string => theme.palette_gray_80};
`;

export const PendingTag = styled.div`
  position: absolute;
  top: -1.25rem;
  padding: 0 ${({ theme }): string => theme.spacing_unit_x2};
  border-radius: ${({ theme }): string => theme.border_radius_infinite};
  right: 0;
  background-color: ${({ theme }): string => theme.palette_warning_50};
  color: ${({ theme }): string => theme.palette_white};
`;
